var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagDanemark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagDanemark_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagDanemark_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagDanemark_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagDanemark_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagDanemark_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BE003A",
    d: "M-8 44.114h70.482V2.998H-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M14.861 44.114h7.616V2.998h-7.616z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M-8 27.363h70.482v-7.621H-8z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iaGlqZzduMTF2YSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSI0bGEyNDF1bG9iIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2hpamc3bjExdmEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiNoaWpnN24xMXZhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjNGxhMjQxdWxvYikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0JFMDAzQSIgZD0iTTAgNDEuMTE0TDcwLjQ4MiA0MS4xMTQgNzAuNDgyIC0wLjAwMiAwIC0wLjAwMnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04IDMpIi8+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0Y0RjRGNCIgZD0iTTIyLjg2MSA0MS4xMTRMMzAuNDc3IDQxLjExNCAzMC40NzcgLTAuMDAyIDIyLjg2MSAtMC4wMDJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOCAzKSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGNEY0RjQiIGQ9Ik0wIDI0LjM2M0w3MC40ODIgMjQuMzYzIDcwLjQ4MiAxNi43NDIgMCAxNi43NDJ6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOCAzKSIvPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgFlagDanemark as ReactComponent };